var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 4.46484H14.8673C15.5304 4.46484 16.1662 4.72824 16.6351 5.19708C17.1039 5.66592 17.3673 6.3018 17.3673 6.96484V8.72318",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30033 1.83203L2.02055 4.11181C1.82528 4.30707 1.82528 4.62366 2.02055 4.81892L4.30033 7.0987",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7003 17.0904H4.16699C3.50395 17.0904 2.86807 16.827 2.39923 16.3581C1.93038 15.8893 1.66699 15.2534 1.66699 14.5904V12.832",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.7237L17.2798 17.4439C17.475 17.2487 17.475 16.9321 17.2798 16.7368L15 14.457",
    stroke: "#7255E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTransferIcon);
export default __webpack_public_path__ + "static/media/DataTransferIcon.0301c0baaa606b022452c049816163c4.svg";
export { ForwardRef as ReactComponent };